import i18n from "../i18n";

const NS = "levelDisplayNames";

const getBundle = () => {
  const lng = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  return i18n.getResourceBundle(lng, NS) || i18n.getResourceBundle("en", NS) || {};
};

export let levelDisplayNames = {};

const refreshLabels = () => {
  levelDisplayNames = getBundle();
};

refreshLabels();
i18n.on("languageChanged", refreshLabels);
